// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__of9D3","active":"RoomScene_active__er-J3"};